import { buildQueryString } from '../../commons/grid/buildQueryString.js';

/**
 * El query string de la grilla de Móviles.
 *
 * Vive aparte por lo mismo que en Tickets: eran 58 concatenaciones a mano dentro del
 * componente (`myQuery += "&base=" + filterQuery.base;`), imposibles de testear sin montar la
 * grilla entera. Acá son dos listas de claves y una función.
 *
 * DOS COSAS QUE NO SE PUEDEN "LIMPIAR" SIN ROMPER EL BACKEND:
 *
 * 1. **Las claves vacías se mandan igual.** `MovilesService::queryFilters()` lee
 *    `$request->getQueryParams()['x']` con `!empty()`, así que un vacío es "sin filtro"; pero
 *    omitir claves cambia el contrato con cualquier otro consumidor que las espere. Se manda
 *    exactamente el mismo juego de claves que antes.
 *
 * 2. **El orden es el que tenía la concatenación.** No cambia nada funcional, pero mantenerlo
 *    hace que el diff de un request contra el anterior sea legible.
 *
 * LO QUE SÍ CAMBIA: ahora los valores van con `encodeURIComponent`. Antes viajaban crudos, así
 * que un `&` en un filtro de texto libre (Modelo, CC. Área, Responsable) inyectaba un parámetro
 * que nadie mandó y un `#` truncaba el resto de la URL.
 */

/** Los filtros, con el mismo nombre de clave que espera el backend. */
export const CAMPOS_DE_FILTRO = [
	'marca', 'estado', 'unidad', 'chasis', 'dominio', 'modelo', 'medidor', 'tipo', 'pais',
	'region', 'subRegion', 'rutas', 'base', 'titular', 'companiaOrigen', 'centroCosto',
	'cecosDireccion', 'cecosMercado', 'cecosGerencia', 'cecosArea', 'responsable1',
	'responsables2', 'filtroKpi', 'showInactivos', 'medidorDesde', 'medidorHasta',
	'supervisores', 'temporales', 'transportadora', 'rentadora', 'funcion', 'esReserva',
	'estadoVinculacion',
];

/**
 * Las columnas ordenables. Viajan como `<campo>Sort`.
 *
 * `supervisor` y `temporal` se agregaron en VEC-3690, arreglando un desajuste que venía de
 * antes: sus encabezados eran clickeables, pero el estado guardaba las claves en plural
 * (`supervisores`/`temporales`), la concatenación no emitía ninguna de las dos y el backend
 * tampoco las conocía. O sea que clickear esas columnas no ordenaba nada, sólo limpiaba el
 * orden que hubiera. Ahora `MovilesService::querySort()` las resuelve por el alias del SELECT,
 * igual que `responsable1`.
 */
export const CAMPOS_DE_ORDEN = [
	'marca', 'estado', 'unidad', 'chasis', 'dominio', 'modelo', 'medidor', 'tipo', 'pais',
	'region', 'subRegion', 'rutas', 'base', 'titular', 'companiaOrigen', 'centroCosto',
	'cecosDireccion', 'cecosMercado', 'cecosGerencia', 'cecosArea', 'responsable1',
	'transportadora', 'rentadora', 'funcion', 'ultimoBipeo', 'supervisor', 'temporal',
];

const paramsDe = (campos, valores, sufijo) => {
	const params = {};
	const origen = valores || {};
	campos.forEach((campo) => {
		params[campo + (sufijo || '')] = origen[campo];
	});
	return params;
};

export const buildMovilesQuery = (pagination, filterQuery, sortQuery) =>
	buildQueryString(Object.assign(
		{ page: (pagination || {}).page, perPage: (pagination || {}).perPage },
		paramsDe(CAMPOS_DE_FILTRO, filterQuery),
		paramsDe(CAMPOS_DE_ORDEN, sortQuery, 'Sort')
	));

export default buildMovilesQuery;
